import jsPDF from "jspdf";

export const generateCertificate = async (
  moduleTitle,
  moduleId,
  score,
  isoAlignment = [],
  employeeName = "Employee"
) => {
  try {
    const doc = new jsPDF("landscape");

    // =========================
    // PAGE BORDER
    // =========================
    doc.setDrawColor(120);
    doc.setLineWidth(1.2);
    doc.rect(10, 10, 277, 190);

    doc.setLineWidth(0.4);
    doc.rect(15, 15, 267, 180);

    // =========================
    // TITLE
    // =========================
    doc.setFont("helvetica", "bold");
    doc.setFontSize(30);
    doc.text("CERTIFICATE OF COMPLETION", 148, 40, {
      align: "center",
    });

    // =========================
    // SUBTITLE
    // =========================
    doc.setFont("helvetica", "normal");
    doc.setFontSize(13);
    doc.text("This is to certify that", 148, 58, {
      align: "center",
    });

    // =========================
    // EMPLOYEE NAME
    // =========================
    doc.setFont("helvetica", "bold");
    doc.setFontSize(24);
    doc.text(employeeName, 148, 74, {
      align: "center",
    });

    // Underline name
    doc.setLineWidth(0.5);
    doc.line(80, 78, 216, 78);

    // =========================
    // COURSE DETAILS
    // =========================
    doc.setFont("helvetica", "normal");
    doc.setFontSize(13);
    doc.text(
      "has successfully completed the training module",
      148,
      92,
      { align: "center" }
    );

    doc.setFont("helvetica", "bold");
    doc.setFontSize(20);
    doc.text(moduleTitle, 148, 108, {
      align: "center",
    });

    // =========================
    // SCORE
    // =========================
    doc.setFont("helvetica", "normal");
    doc.setFontSize(14);
    doc.text(`Score Achieved: ${score}%`, 148, 124, {
      align: "center",
    });

    // =========================
    // ISO ALIGNMENT (optional)
    // =========================
    if (isoAlignment.length > 0) {
      doc.setFontSize(11);
      doc.text(
        `Aligned Standards: ${isoAlignment.join(", ")}`,
        148,
        136,
        { align: "center" }
      );
    }

    // =========================
    // FOOTER (ONLY DATE)
    // =========================
    const date = new Date().toLocaleDateString();

    doc.setFontSize(10);
    doc.text(`Issued on: ${date}`, 25, 182);

    // Signature line
    doc.line(210, 170, 260, 170);
    doc.text("Authorized Signature", 235, 178, {
      align: "center",
    });

    // =========================
    // DOWNLOAD
    // =========================
    doc.save(`Certificate_${moduleTitle}.pdf`);

    return true;
  } catch (error) {
    console.error("Certificate generation failed", error);
    throw error;
  }
};